interface AdminTabsProps<K extends string> {
  value: K;
  onChange: (key: K) => void;
  items: ReadonlyArray<{ key: K; label: string }>;
}

export const AdminTabs = <K extends string>({ value, onChange, items }: AdminTabsProps<K>) => (
  <div role="tablist" className="flex items-center gap-1 border-b border-zinc-200">
    {items.map(item => {
      const active = item.key === value;
      return (
        <button
          key={item.key}
          type="button"
          role="tab"
          aria-selected={active}
          onClick={() => onChange(item.key)}
          className={[
            'h-9 px-3 -mb-px text-sm border-b-2 transition-colors duration-100',
            active
              ? 'border-zinc-900 text-zinc-900 font-medium'
              : 'border-transparent text-zinc-500 hover:text-zinc-900 hover:border-zinc-300',
          ].join(' ')}
        >
          {item.label}
        </button>
      );
    })}
  </div>
);
